var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxCloseGreen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.042,
    height: 24.042,
    viewBox: "0 0 24.042 24.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #35b36a;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close_X",
    "data-name": "close X",
    transform: "translate(1.041 1.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M.5,0V29.865",
    transform: "translate(21.138 0.02) rotate(45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5-2",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M30,.5H0",
    transform: "translate(0.727 0.02) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxCloseGreen);
export default __webpack_public_path__ + "static/media/rx-close-green.d5a4d909f97e1b96e3907f58188d12c5.svg";
export { ForwardRef as ReactComponent };